import CoreUtils from '../../../utils/coreUtils.js';
import Node from '../node.js';
import { PARAM_TYPE } from '../connector.js';

export default class NodeInterpolate extends Node
{
	static INTERPOLATION_CHOICES =
	[
		{key: 'linear', label: 'Linear'},
		{key: 'easeInOut', label: 'Ease In, Ease Out'},
	]

	constructor(pParent)
	{
		super(pParent);

		this.addInput(PARAM_TYPE.FLOAT, 'input_value', 0.5);
		this.addInput(PARAM_TYPE.FLOAT, 'target_range_min', 0);
		this.addInput(PARAM_TYPE.FLOAT, 'target_range_max', 1);
		this.addInput(PARAM_TYPE.BOOLEAN, 'use_custom_input_range', false);
		this.addInput(PARAM_TYPE.FLOAT, 'input_value_range_min', 0);
		this.addInput(PARAM_TYPE.FLOAT, 'input_value_range_max', 100);
		this.addInput(PARAM_TYPE.DROPDOWN, 'interpolation_type', NodeInterpolate.INTERPOLATION_CHOICES[0].key, { dropdownOptions: NodeInterpolate.INTERPOLATION_CHOICES });
		this.addInput(PARAM_TYPE.BOOLEAN, 'inverse_interpolation', false);

		this.addOutput(PARAM_TYPE.FLOAT, 'result');
	}

	getType()
	{ 
		return 'interpolate';
	}

	getIsInputEnabledSubclass(strInputName)
	{
		const lastResult = this.getLastInputResult('use_custom_input_range');
		if(strInputName === 'input_value_range_min' || strInputName === 'input_value_range_max')
			return lastResult;
		return true;
	}

	generateSubclass(scene, inputValues, outputName, computedOutputResults)
	{
		let normalizedInterpValue = inputValues['input_value'];
		if(inputValues['use_custom_input_range'])
			normalizedInterpValue = (inputValues['input_value'] - inputValues['input_value_range_min'])/(inputValues['input_value_range_max'] - inputValues['input_value_range_min']);

		if(inputValues['inverse_interpolation'])
			normalizedInterpValue = 1.0 - normalizedInterpValue;

		if(inputValues['interpolation_type'] === 'easeInOut')
			normalizedInterpValue = CoreUtils.convertLinearToEaseInOutInterpolation(normalizedInterpValue);

		return CoreUtils.interpolate(normalizedInterpValue, inputValues['target_range_min'], inputValues['target_range_max']);
	}
}